(function ($) {
    async function getShopInfo() {
       
        const {code, data} = await __Xtool_Utils.fetchJSON(`${__Xtool_Utils.getXccApiDomain()}/xtool-creators-club/v1/shop?store=${__Xtool_Utils.getStore()}`);
        if (code === 0) {
            window.localStorage.setItem('shopInfo', JSON.stringify(data));
        } else {
            console.error('获取店铺信息失败', data);
        }
    }

    theme.AssetsLoader.onPageLoaded(function () {
        getShopInfo();

    });
})(jQueryTheme);